import { useRef, useState, useEffect } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";

const options = {
  disableDefaultUI: true,
  zoomControl: false,
  panControl: false,
  rotateControl: false,
  scaleControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  mapTypeControl: false,
  keyboardShortcuts: false,
};

const AddressMap = ({ data, setData, setErrors }) => {
  const [center, setCenter] = useState({
    lat: 29.2266,
    lng: 47.9689,
  });
  const [icon, setIcon] = useState(null);
  const mapRef = useRef(null);
  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  useEffect(() => {
    if (
      !isNaN(parseFloat(data?.latitude)) &&
      !isNaN(parseFloat(data?.longitude))
    ) {
      setCenter({
        lat: parseFloat(data?.latitude),
        lng: parseFloat(data?.longitude),
      });
    } else if (
      !isNaN(parseFloat(data?.street?.latitude)) &&
      !isNaN(parseFloat(data?.street?.longitude))
    ) {
      setCenter({
        lat: parseFloat(data?.street?.latitude),
        lng: parseFloat(data?.street?.longitude),
      });
    }
  }, [data?.street, data?.latitude, data?.longitude]);

  if (!window.google) return null;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      options={options}
      onLoad={(map) => {
        mapRef.current = map;
        setIcon({
          url: `${process.env.REACT_APP_PUBLIC_URL}assets/images/icons/branch.png`,
          scaledSize: new window.google.maps.Size(50, 50),
        });
      }}
    >
      <Marker
        position={center}
        draggable={true}
        onDragEnd={(e) => {
          const newLat = e.latLng?.lat();
          const newLng = e.latLng?.lng();
          setData((prev) => ({ ...prev, latitude: newLat, longitude: newLng }));
          setErrors((prev) => ({ ...prev, latitude: "", longitude: "" }));
        }}
        icon={icon}
      />
    </GoogleMap>
  );
};

export default AddressMap;
